/**
 * A backend UTC ISO-8601 időbélyeget ad; a felhasználó budapesti időt vár.
 *
 * Ugyanaz a döntés, mint az Androidon (`feature/shared/Labels.kt`) — ott is
 * kifejezetten javítani kellett, mert a nyers UTC két órával korábbi
 * eseményt mutatott, és ez egy műszak közben félrevezető.
 */
const formatter = new Intl.DateTimeFormat('hu-HU', {
  timeZone: 'Europe/Budapest',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
});

export function formatTimestamp(iso: string | null | undefined): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return formatter.format(date);
}
